import Paper from "@mui/material/Paper";
import PropTypes from "prop-types";
import "./DisplayPage.scss";

const DisplayPage = ({ children }) => {
  return (
    <div className="display__page">
      <Paper className="display__page__paper">
        <div className="display__page__paper__container">{children}</div>
      </Paper>
    </div>
  );
};

export default DisplayPage;

DisplayPage.propTypes = {
  children: PropTypes.node,
};
